module.exports = __webpack_public_path__ + "static/media/Profil.f4300b48.png";